import { Directive, HostListener, Inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';

import { SearchAction } from '@hiptraveler/data-access/search';
import { Location } from '@angular/common';
import { cleanObject, objectToQueryString, queryStringToObject, SearchLocationService, WINDOW } from '@hiptraveler/common';
import { DataAccessService } from '../common';
import { FiltersService } from '../filters.service';
import { ProfileListService } from '../../data-services';

@Directive({
  selector: '[clearNameAction]'
})
export class  ClearNameActionDirective {

  constructor(
    @Inject(WINDOW) private window: any,
    private location: Location,
    private store: Store,
    private profileList: ProfileListService,
    private dataAccess: DataAccessService,
    private searchLocation: SearchLocationService,
    private service: FiltersService
  ) { }

  @HostListener('click')
  async hostClicked(): Promise<void> {

    if (!this.service.form.value.query) return;
    this.clearNameQuery();

    const form = this.service.form.value;

    switch (this.service.path) {
      case 'thingstodo':   return this.dataAccess.adventures(form);
      case 'hotels':       return this.dataAccess.hotels(form);
      case 'foodanddrink': return this.dataAccess.foods(form);
      case 'community':    {
        await firstValueFrom(this.store.dispatch(new SearchAction.ResetSearchState([ 'communities', 'pagination' ])));
        return this.profileList.getSearchResultsByLocation(this.searchLocation.data);
      }
    }
  }

  clearNameQuery(): void {
    this.service.form.patchValue({ query: '' });
    const query = cleanObject({
      ...queryStringToObject(this.window.location.search),
      keyword: ''
    });
    const newUrl = `${this.window.location.pathname}${objectToQueryString(query) ? '?' : ''}${objectToQueryString(query)}`;
    this.location.replaceState(newUrl);
  }

}
